import { FC, memo } from "react";
import { useSelector } from "react-redux";
import { IntlProvider } from "react-intl";
import { mapLocale, mapMessages } from "store/reducers/intl";

interface IProps {
  children: JSX.Element;
}

const IntlWrap: FC<IProps> = ({ children }) => {
  const locale = useSelector(mapLocale);
  const messages = useSelector(mapMessages);

  return (
    <IntlProvider locale={locale} key={locale} messages={messages}>
      {children}
    </IntlProvider>
  );
};

export default memo(IntlWrap);
